<section class="loginPage">
  <div class="container">
      <div class="verificationWrap setPassword">
          <a href="javascript:void(0);" routerLink="/settings/verify" class="bkbtn mb-2"><img src="assets/images/arrow_back.svg" class="ht"> Back</a>
          <div class=" subHeader">
              <h2 class="mainTitle"> Change password</h2>
              <p> Create your own strong password. </p>
          </div>

          <form [formGroup]="form" (ngSubmit)="resetPassword()">
               <div class="form-group mb-4">
                  <label>Current Password </label>
                  <input  type="{{showPwd?'text':'password'}}" class="form-control" name="password" placeholder="Enter password"  id="password" formControlName="password"  (keyup)="keyup($event)"/>
                  <a href="javascript:void(0);" [class]="showPwd? 'hide':'show'" (click)="showPwd= !showPwd"> 
                    <img class="hide" [src]="showPwd? '../../../assets/images/password.svg':'../../../assets/images/ic_eye_open.svg'" alt="password"> 
                    <i ></i>
                  </a> 
                  
                <div class="text-danger" *ngIf="form.controls['password'].hasError('required') && showError">
                    *Please enter new password.
                </div>
                <div class="text-danger" *ngIf="form.value.password.includes(' ') && showError">
                    *Space not allowed in password.
                </div>
              </div>
              
              <div class="form-group mb-4">
                  <label>New Password </label>
                  <input  type="{{showNewPwd?'text':'password'}}" class="form-control" name="newPassword" placeholder="Enter password"  id="newPassword" formControlName="newPassword"  (keyup)="keyup($event)"/>
                  <a href="javascript:void(0);" [class]="showNewPwd? 'hide':'show'" (click)="showNewPwd= !showNewPwd"> 
                    <img class="hide" [src]="showNewPwd? '../../../assets/images/password.svg':'../../../assets/images/ic_eye_open.svg'" alt="password"> 
                    <i ></i>
                  </a> 
                <div class="text-danger" *ngIf="form.controls['newPassword'].hasError('required') && showError">
                    *Please enter new password.
                </div>
                <div class="text-danger" *ngIf="form.value.newPassword.includes(' ') && showError">
                    *Space not allowed in password.
                </div>
              </div>
              <div class="form-group mb-4">
                  <label>Confirm Password </label>
                  <input  type="{{showReNewPwd?'text':'password'}}" class="form-control" name="password2" placeholder="Enter password"  id="password2" formControlName="password2"  (keyup)="keyup($event)"/>
                  <a href="javascript:void(0);" [class]="showReNewPwd? 'hide':'show'" (click)="showReNewPwd= !showReNewPwd"> 
                    <img class="hide" [src]="showReNewPwd? '../../../assets/images/password.svg':'../../../assets/images/ic_eye_open.svg'" alt="password"> 
                    <i ></i>
                  </a> 
              </div>
              <div class="text-danger" *ngIf="(showError) || ((form.value.newPassword && form.value.password2) && (form.value.newPassword != form.value.password2))">
                  *Password does not match. Please try again.
              </div>
              <ul class="selectpasswordType">
                <li [ngClass]="form.value.newPassword.length == 0 ? '': (form.value.newPassword.length > 7 ? 'active':'text-danger')"> Minimum 8 characters </li>
                <li [ngClass]="form.value.newPassword.length == 0 ? '' : (upper > 0 ? 'active' : 'text-danger')"> Minimum 1 uppercase </li>
                <li [ngClass]="form.value.newPassword.length == 0 ? '' : (number > 0 ? 'active' : 'text-danger')"> Minimum 1 number  </li>
                <li [ngClass]="form.value.newPassword.length == 0 ? '' : (special > 0 ? 'active' : 'text-danger')"> At least 1 special character </li>
            </ul>

              <div class="form-group">
                  <!-- <a href="javascript:void(0);" routerLink="settings" class="commonBtn mt-5"> Save Changes </a> -->
                  <input type="submit" value="Save Changes" class="commonBtn mt-5"/>
              </div>

          </form>
      </div>
  </div>
</section>

<!-- End -->

